import { Typography } from "@mui/material";
import { getFormattedInterval } from "./predictionView.util";

const SinglePredictionInterval = ({ interval, timezone, predictionType }) => {

    const formatted = getFormattedInterval(interval, timezone, predictionType);

    return (
        <Typography
            variant="caption"
            color="primary.main"
            sx={{
                display: "block",
                mb: 1,
                fontSize: "0.875rem",
                fontWeight: "medium",
            }}
        >
            {formatted.start} - {formatted.end}
        </Typography>
    );
};

export default SinglePredictionInterval;


